import React, { useContext } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import Footer from "./components/Footer";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import StudentDashboard from "./pages/StudentDashboard";
import Profile from "./pages/Profile";
import Status from "./pages/Status";
import AuditPage from "./pages/AuditPage";
import AdminDashboard from "./pages/AdminDashboard";
import Stories from "./pages/Stories";
import Eligibility from "./pages/Eligibility";
import Support from "./pages/Support";
import OurStory from "./pages/AboutUs";
import Leadership from "./pages/Leadership";
import AnnualReports from "./pages/AnnualReport";
import DataPrivacy from "./pages/DataPrivacy";
import NotFound from "./pages/NotFound";
import ApplicationConfirmation from "./pages/ApplicationConfirmation";
import { AuthContext } from "./context/AuthContext";
import ApplicationForm from "./components/ApplicationForm";
import AdminLogin from "./pages/AdminLoginPage";
import Requirements from "./pages/Requirements";
import AdminLayout from "./components/AdminLayout";
import StudentLayout from "./components/StudentLayout";
import PublicLayout from "./components/PublicLayout";
import BudgetCyclePage from "./pages/BudgetCyclePage";
import DisbursementPage from "./pages/DisbursementPage";
import ReportsPage from "./pages/ReportsPage";


/* ================= ROUTE GUARDS ================= */

const StudentRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "STUDENT") return <Navigate to="/" replace />;
  return children;
};

const AdminRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  if (!user) return <Navigate to="/admin-login" replace />;
  const isAdmin = ["ADMIN", "WARD_ADMIN", "CDF_ADMIN"].includes(user.role);
  return isAdmin ? children : <Navigate to="/" replace />;
};


/* ================= APP ================= */

const App = () => {
  const location = useLocation();
  const hideFooterRoutes = ["/login", "/register", "/admin-login"];
  const hideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <div className="flex flex-col min-h-screen">
      <Routes>

        {/* ── PUBLIC ROUTES ── */}
        <Route element={<PublicLayout />}>
          <Route path="/"             element={<Home />} />
          <Route path="/login"        element={<Login />} />
          <Route path="/register"     element={<Register />} />
          <Route path="/requirements" element={<Requirements />} />
          <Route path="/eligibility"  element={<Eligibility />} />
          <Route path="/stories"      element={<Stories />} />
          <Route path="/support"      element={<Support />} />
          <Route path="/about"        element={<OurStory />} />
          <Route path="/leadership"   element={<Leadership />} />
        </Route>

        {/* ── STUDENT ROUTES ── */}
        <Route
          element={
            <StudentRoute>
              <div className="flex flex-col min-h-screen">
                <StudentLayout />
              </div>
            </StudentRoute>
          }
        >
          <Route path="/student-dashboard"             element={<StudentDashboard />} />
          <Route path="/student-dashboard/profile"     element={<Profile />} />
          <Route path="/student-dashboard/application" element={<ApplicationForm />} />
          <Route path="/student-dashboard/status"      element={<Status />} />
          <Route path="/applications/confirmation"     element={<ApplicationConfirmation />} />
          <Route path="/annual-reports"                element={<AnnualReports />} />
          <Route path="/data-privacy"                  element={<DataPrivacy />} />
        </Route>

        {/* ── ADMIN ROUTES ── */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route
          path="/admin-dashboard"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index        element={<AdminDashboard />} />
          <Route path="audit"         element={<AuditPage />} />
          <Route path="budget"        element={<BudgetCyclePage />} />
          <Route path="disbursements" element={<DisbursementPage />} />
          <Route path="reports"       element={<ReportsPage />} />
        </Route>

        {/* ── 404 ── */}
        <Route path="*" element={<NotFound />} />

      </Routes>

      {!hideFooter && <Footer />}
    </div>
  );
};

export default App;
